import { render, staticRenderFns } from "./DialogData.vue?vue&type=template&id=94602ce6&"
import script from "./DialogData.vue?vue&type=script&lang=ts&"
export * from "./DialogData.vue?vue&type=script&lang=ts&"
import style0 from "./DialogData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports